import queryString from 'query-string';
// import reportException from 'lib/errorReporter';

const sessionStorage = window?.sessionStorage;

export function shouldWriteToConsole() {
  const shouldWrite = (sessionStorage && sessionStorage.consolv) ||
    (typeof queryString.parse(window.location.search).consolv !== 'undefined') ||
    (buildEnv && buildEnv.NODE_ENV === 'development');
  if (sessionStorage && shouldWrite) sessionStorage.consolv = true;
  return shouldWrite;
}

/* eslint-disable no-console */
function log(...args) {
  if (console.log && shouldWriteToConsole()) console.log(...args);
}

function error(...args) {
  // reportException(args[0]);
  if (console.error && shouldWriteToConsole()) console.error(...args);
}
/* eslint-enable no-console */

export default ({ log, error });
